import React from 'react';
import api from '@tutorbot/directory-api';
import BlogSubscribe from './blogSubscribe';
import { UserContext } from '../../hoc/User';
import { LocalizationContext } from '../../hoc/Localization';
import styles from './styles.less';
import Subscribe from '../../components/Home/Subscribe';
import { getCookie, setCookie } from '../../utils/cookies';
import { RouteContext } from '../../hoc/Route';

const ModalSubscribe = () => {
  const { params, page } = React.useContext(RouteContext);
  const { user } = React.useContext(UserContext);
  const [visible, setVisible] = React.useState(false);
  const [items, setItems] = React.useState([]);
  const [categoriesType, setCategoriesType] = React.useState([]);
  const { t } = React.useContext(LocalizationContext);

  React.useEffect(() => {
    (async () => {
      const allCategories = (await api().categories.get()).data;
      const filterCategories = allCategories
        .filter(item => item.blogCategory !== null)
        .map(it => it.label);
      setCategoriesType(filterCategories);
    })();
  }, []);

  React.useEffect(() => {
    const blogCookies = getCookie('BlogCategories');
    if (!blogCookies) {
      setTimeout(() => {
        setVisible(true);
      }, 5000);
    }
  }, [categoriesType]);

  const hideModal = () => {
    const blogCookies = getCookie('BlogCategories');
    if (!(blogCookies === 'noUser' || (user && blogCookies === user.id))) {
      setCookie('BlogCategories', user ? user.id : 'noUser');
    }
    setVisible(false);
  };
  const handleAddCategoriesType = (category, checked) =>
    (checked
      ? setItems(prevState => [...prevState, category])
      : setItems([...items.filter(i => i !== category)]));
  function changeClassName() {
    if (visible) {
      return 'subscribeModalBlogContainer';
    }
    return 'hideSubscribeModal';
  }
  return (
    <div className={styles[changeClassName()]} maskClosable={false}>
      <div className={styles.subscribeBlogHeader}>
        <div className={styles.blogSubscribeTitle}>{t('frontpage.newsletter.heading')}</div>
        <div onClick={hideModal}>
          <img src="/static/images/course/closeModal.svg" alt="close" />
        </div>
      </div>
      {categoriesType && (
        <div className={styles.wrapped}>
          <div className={styles.categories}>
            {categoriesType &&
              categoriesType.map(item => (
                <div key={item} style={{ padding: '2px' }}>
                  <div className={styles.cat_types}>
                    <BlogSubscribe
                      onSelect={e => handleAddCategoriesType(item, e)}
                      cat={t(`blog.${item}.subscribe`)}
                    />
                  </div>
                </div>
              ))}
          </div>
          <Subscribe
            onSubmit={hideModal}
            categories={
              items.length ? items : [`subscribe page ${page || params.category || 'article'}`]
            }
            pageSuffix="_blogPopup"
          />
        </div>
      )}
    </div>
  );
};

export default ModalSubscribe;
